import { request } from "../client"

export type OrganizationOnboardingStepKey =
  | "CUSTOMER_IMPORT"
  | "EMPLOYEES"
  | "CALENDAR_INTEGRATION"
  | "ORGANIZATION_SETTINGS"
  | "PLANNING_SETTINGS"
  | "BATCH_PLANNING"

export type OrganizationOnboardingStepStatus = "OPEN" | "COMPLETED" | "SKIPPED"

export type OrganizationOnboardingStepAction =
  | "customer_import"
  | "manage_employees"
  | "connect_calendar"
  | "organization_settings"
  | "planning_settings"
  | "batch_planning"

export type OrganizationOnboardingSummaryTone = "neutral" | "success" | "warning"
export type OrganizationOnboardingSummaryItemStatus = "ready" | "missing" | "warning" | "neutral"

export type OrganizationOnboardingSummaryMetric = {
  label: string
  value: string
  tone?: OrganizationOnboardingSummaryTone
}

export type OrganizationOnboardingSummaryItem = {
  label: string
  detail?: string | null
  status: OrganizationOnboardingSummaryItemStatus
}

export type OrganizationOnboardingStepSummary = {
  headline: string
  description?: string | null
  metrics: OrganizationOnboardingSummaryMetric[]
  items: OrganizationOnboardingSummaryItem[]
  empty_label?: string | null
}

export type OrganizationOnboardingStep = {
  key: OrganizationOnboardingStepKey
  title: string
  description: string
  status: OrganizationOnboardingStepStatus
  explicit_status?: OrganizationOnboardingStepStatus | null
  derived_completed: boolean
  completed_at?: string | null
  skipped_at?: string | null
  primary_action: OrganizationOnboardingStepAction
  can_skip: boolean
  summary?: OrganizationOnboardingStepSummary | null
}

export type OrganizationOnboardingResponse = {
  organization_id: string
  completed: boolean
  active_step_key?: OrganizationOnboardingStepKey | null
  steps: OrganizationOnboardingStep[]
}

export const updateOrganizationOnboardingStep = (
  organizationId: string,
  stepKey: OrganizationOnboardingStepKey,
  status: Exclude<OrganizationOnboardingStepStatus, "OPEN">,
): Promise<OrganizationOnboardingResponse> =>
  request<OrganizationOnboardingResponse>(
    `/organizations/${encodeURIComponent(organizationId)}/onboarding/steps/${encodeURIComponent(stepKey)}`,
    {
      method: "PATCH",
      body: JSON.stringify({ status }),
    },
  )
